import useDynamicSvgImport from "@/hooks/general/useDynamicImport.tsx";
import { SVGProps } from "react";
import classNames from "classnames";

export type TSvgIconProps = {
  iconName: string;
  className?: string;
  fill?: string;
  directory?: string;
} & SVGProps<SVGSVGElement>;

const SvgIcon = (props: TSvgIconProps) => {
  const {
    iconName,
    className,
    fill = "fill-gray-400",
    directory,
    ...rest
  } = props;
  const { Icon } = useDynamicSvgImport(iconName, directory);

  return (
    <div>
      {!!Icon && (
        <Icon
          className={classNames(`${fill}`, className, {
            "svg-icon": fill !== "fill-unset",
          })}
          {...rest}
        />
      )}
    </div>
  );
};

export default SvgIcon;
